<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chigermano0009#ch01"><b>1</b>   Press start</a></p>
<p class="toc"><a class="xref" href="#/chigermano0010#ch02"><b>2</b>   Good to better</a></p>
<p class="toc"><a class="xref" href="#/chigermano0011#ch03"><b>3</b>   Know what you’ve got</a></p>
<p class="toc"><a class="xref" href="#/chigermano0012#ch04"><b>4</b>   Look for an argument</a></p>
<p class="toc"><a class="xref" href="#/chigermano0013#ch05"><b>5</b>   Build an architecture</a></p>
<p class="toc"><a class="xref" href="#/chigermano0014#ch06"><b>6</b>   Remember the audience</a></p>
<p class="toc"><a class="xref" href="#/chigermano0015#ch07"><b>7</b>   What writing wants</a></p>
<p class="tocbmf"><a class="xref" href="#/chigermano0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chigermano0017#bib">A very short bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chigermano0018#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chigermano0019#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-germano-0008.vue?24465972